{
	"backToManageDeclarations": "Wróć do: Zarządzaj deklaracjami"
}
